<template>
    <div class="errorScreen" v-if="errorExists">
        <h1>{{status}}</h1>
        <h1 v-if="title">{{title}}</h1>
        <p>{{message}}</p>
    </div>
</template>

<script>
export default {
    name: 'error',
    data: () => ({
        status: 404,
        title: "Not Found",
        message: "",
        errorExists: false
    }),
    methods: {
        showError: function({status, title = "", message}) {
            var globv = this;
            globv.status = status;
            globv.title = title;
            globv.message = message;
            globv.errorExists = true;
        },
        reset: function() {
            var globv = this;
            globv.errorExists = false;
        }
    }
}
</script>

<style lang="scss">
.errorScreen {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: lightgrey;
    background-color: var(--dashBackgroundColor);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    h1 {
        font-size: 10vw;
    }

    p {
        font-size: 2rem;
    }
}

@media (max-width: 400px) {
    .errorScreen {
        h1 {
            font-size: 2rem;
        }

        p {
            font-size: 1rem;
        }
    }
}
</style>